export default "__VITE_ASSET__1f56ec25__"